module.exports = __webpack_public_path__ + "img/id.8694d4a0.jpg";